import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomPaper from "../common/customPaper";
import FiltersButton from "../common/FiltersButton";
import { DateRangePicker } from "../filters/DateRangePicker";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";
import { Upload } from "lucide-react";

const CustomActionPanel = ({
    header,
    onClose,
    filterCta,
    children,
    padding,
    dateRange,
    handleDateRangeChange,
    filtersCount,
    range,
    exportToExcel,
    isShowDateRange = false,
    isShowFilters = false,
    removePadding = false,
    displayExportToExcel=false
}) => {
    const { getFontSize } = useResponsiveStyles();
    return (
        <CustomPaper alignItems="left" removePadding={removePadding}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography
                    // variant="h6"
                    sx={{ ...getFontSize("heading"), color: "#C43A29" }}
                    className="text-primary font-bold"
                >
                    {header}
                </Typography>
                <Box display="flex" alignItems="center">
                    {filterCta && displayExportToExcel && (
                        <div className="flex gap-2" style={{cursor: 'pointer'}} onClick={() => exportToExcel()}>
                            <Upload className="text-primary" size={16}/>
                            <Typography className="text-primary" sx={{fontSize: 12, width: '80px'}}>
                                Export to Excel
                            </Typography>
                        </div>
                    )}
                    {!isShowDateRange && (
                        <>
                            {handleDateRangeChange && (
                                <DateRangePicker
                                    dateRange={dateRange}
                                    onDateRangeChange={handleDateRangeChange}
                                    borderColor="#767676"
                                    customStyles={{ margin: "0 10px" }}
                                    customPopoverStyle={{ right: "-150px" }}
                                    range={range}
                                />
                            )}
                        </>
                    )}
                    
                    {!isShowFilters && (
                        <>
                            {filterCta && (
                                <FiltersButton
                                    onClick={filterCta}
                                    filtersCount={filtersCount}
                                />
                            )}
                        </>
                    )}

                    <IconButton
                        onClick={onClose}
                        sx={styles.iconButton}
                        disableRipple
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>
            <Box sx={styles.renderArea}>{children}</Box>
        </CustomPaper>
    );
};

const styles = {
    iconButton: {
        color: "#C43A29",
        ml: 1,
        paddingRight: 0,
    },
    renderArea: {
        height: "calc(100vh - 3.2rem)",
    },
};

CustomActionPanel.propTypes = {
    header: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    filterCta: PropTypes.func,
    children: PropTypes.node.isRequired,
    isShowDateRange: PropTypes.bool,
};

export default CustomActionPanel;
